import React from 'react';
import { ModalProps } from '../../../../components/Modal';
import { ReactComponent as WarningModal } from '../../../../assets/warningModal.svg';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { useScheduleContext } from '../../../../contexts/ScheduleContext';
import { useServiceContext } from '../../../../contexts/ServiceContext';
import { useSpecialistContext } from '../../../../contexts/SpecialistContext';
import { FirebaseEvents } from '../../../../utils/enums/firebase-events';
import ContainerModal from '../../../../components/ContainerModal';

import { ReactComponent as WhatsAppIcon } from '../../../../assets/whatsapp-rounded.svg';
import { ReactComponent as CallCenterIcon } from '../../../../assets/call-center-rounded.svg';
import { ReactComponent as Arrow } from '../../../../assets/arrow-black-right.svg';

import { Button } from '../../../../components';
import { useRemoteConfig } from '../../../../hooks/useRemoteConfig';
import { maskPhone } from '../../../../utils/masks';

import * as S from './styles';
import { envConfig } from '../../../../utils/enviroment';

export type modalProps = Pick<ModalProps, 'visible' | 'onClose'>;

export const HealthCarePaymentModal: React.FC<modalProps> = ({ onClose, visible }) => {
  const { logEvent } = useAnalytics();
  const { scheduleSpecialistSelected } = useScheduleContext();
  const { selectedService } = useServiceContext();
  const { selectedSpecialist } = useSpecialistContext();

  const { getRemoteConfigValue } = useRemoteConfig();

  React.useEffect(() => {
    if (visible)
      logEvent({
        eventName: FirebaseEvents.schedule_health_insurance_restriction,
        eventParams: {
          service_id: selectedService.id,
          service_name: selectedService.name,
          product_name: selectedSpecialist?.name,
          product_id: selectedSpecialist?.id,
          unit_id: scheduleSpecialistSelected?.unit?.catalogId,
          unit_name: scheduleSpecialistSelected?.unit?.name,
          reason: 'Ainda não é possível agendar por aqui'
        }
      });
  }, [visible]);

  const getWhatsappContactValue = () => {
    const whatsappContact = getRemoteConfigValue('specialist_whatsapp_contact');
    if (whatsappContact) return whatsappContact;
    return envConfig.REACT_CALL_CENTER_WHATSAPP_CONTACT;
  };

  const getCallCenterContactValue = () => {
    const callCenterContact = getRemoteConfigValue('specialist_call_center_contact');
    if (callCenterContact) return callCenterContact;
    return '1121511233';
  };

  return (
    <ContainerModal
      visible={visible}
      onClose={onClose}
      withoutCloseButton
      childrenFooter={<Button type="button" title="Fechar" onClick={onClose} />}
    >
      <S.Container>
        <WarningModal />
        <h3 className="title">Aviso importante</h3>
        <p className="subtitle">
          Para seguir com o agendamento, entre em contato com a nossa central de atendimento por telefone ou WhatsApp.
        </p>
        <p className="subtitle">Atendimento disponível de segunda a sexta, das 07:00 às 19:00, exceto feriados.</p>
        <S.ContactWrapper href={`tel:${getCallCenterContactValue()}`}>
          <S.IconWrapper>
            <CallCenterIcon />
          </S.IconWrapper>
          <S.InfoContainer>
            <S.ContactTitle>{`Call Center ${maskPhone(getCallCenterContactValue())}`}</S.ContactTitle>
            <Arrow />
          </S.InfoContainer>
        </S.ContactWrapper>

        <S.ContactWrapper
          onClick={() => window.open(`https://api.whatsapp.com/send?phone=55${getWhatsappContactValue()}`, '_blank')}
        >
          <S.IconWrapper>
            <WhatsAppIcon />
          </S.IconWrapper>
          <S.InfoContainer>
            <S.ContactTitle>{`WhatsApp ${maskPhone(getWhatsappContactValue())}`}</S.ContactTitle>
            <Arrow />
          </S.InfoContainer>
        </S.ContactWrapper>
      </S.Container>
    </ContainerModal>
  );
};
